import { Outlet } from "react-router-dom";
import { AdminGuard } from "@/components/auth/AdminGuard";
import { Badge } from "@/components/ui/badge";

/**
 * Frames every /admin/* page. The admin navigation now lives in the left
 * sidebar (operator view), so this just guards the routes and adds a small
 * page-level "Admin" tag above the routed content.
 */
export function AdminLayout() {
  return (
    <AdminGuard>
      <div className="space-y-5 sm:space-y-6">
        <div className="flex flex-wrap items-center gap-2">
          <Badge variant="soft">Admin</Badge>
          <p className="text-xs text-muted-foreground">Platform operator view.</p>
        </div>
        <Outlet />
      </div>
    </AdminGuard>
  );
}
